module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_6.e387bb7a.png";